/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect } from 'react';
import { VenueService } from 'components/templates/service';
import { LANGUAGE_OPTIONS, VENUN_OPTION_LIST } from 'libs/constants';
import { withRouter, NextRouter } from 'next/router';

interface MediaPageProps {
  router: NextRouter;
  lang: string;
}

const MediaPage: React.FC<MediaPageProps> = ({ router, lang }) => {
  // const router = useRouter();

  useEffect(() => {
    if (router) {
      router.push(`/${lang}/service/venue-service`, undefined, {
        scroll: false,
      });
    }
  }, [router, lang]);

  const handleOptionSelected = useCallback(
    (tab: number) => {
      const optionList = VENUN_OPTION_LIST as any;
      if (optionList[tab]) {
        const optionItem = optionList[tab] as any;
        router.push(`/${lang}${optionItem.link}`, undefined, {
          scroll: false,
        });
      }
    },
    [lang, router]
  );
  return <VenueService onOptionSelected={handleOptionSelected} />;
};

export default withRouter(MediaPage);

export async function getStaticPaths() {
  // generate path for static generation
  const paths: any = [];
  LANGUAGE_OPTIONS.forEach((item: any) => {
    paths.push({
      params: {
        lang: item.value,
      },
    });
  });
  return { paths, fallback: false };
}

export async function getStaticProps(args: any) {
  const { lang } = args.params;

  return {
    props: {
      lang,
    },
  };
}
